export default "__VITE_ASSET__CRX61HUn__"